import Raven from 'raven-js';
const BOT_USER_AGENT_REGEX = /bot|crawler|spider|googlebot|bingbot|yandex|baidu|slurp|duckduck|facebookexternalhit|linkedinbot|twitterbot|applebot|semrush|ahref|mj12bot|dotbot|petalbot|bytespider/i;
/**
 * Returns `false` to drop the event before it reaches Sentry. Drops:
 *  - any event whose User-Agent looks like a known bot or crawler
 *  - CHIRP/fetch errors paired with a breadcrumb that has status_code 0
 *    or null (network drops, ad-blocker interference, etc.)
 */
export function shouldSendToRaven(data) {
  var _data$request, _data$exception, _data$breadcrumbs;
  const userAgent = (data === null || data === void 0 || (_data$request = data.request) === null || _data$request === void 0 || (_data$request = _data$request.headers) === null || _data$request === void 0 ? void 0 : _data$request['User-Agent']) || '';
  if (BOT_USER_AGENT_REGEX.test(userAgent)) {
    return false;
  }
  const errorMessage = (data === null || data === void 0 || (_data$exception = data.exception) === null || _data$exception === void 0 || (_data$exception = _data$exception.values) === null || _data$exception === void 0 || (_data$exception = _data$exception[0]) === null || _data$exception === void 0 ? void 0 : _data$exception.value) || '';
  const isChirpOrFetchError = errorMessage.includes('CHIRP RPC failed') || errorMessage.includes('Network request failed') || errorMessage.includes('Failed to fetch') || errorMessage.includes('HTTP RPC failed');
  const breadcrumbs = (data === null || data === void 0 || (_data$breadcrumbs = data.breadcrumbs) === null || _data$breadcrumbs === void 0 ? void 0 : _data$breadcrumbs.values) || [];
  const hasStatusCode0OrNull = breadcrumbs.some(crumb => {
    var _crumb$data, _crumb$data2, _crumb$data3;
    return (crumb.category === 'xhr' || crumb.category === 'fetch') && (((_crumb$data = crumb.data) === null || _crumb$data === void 0 ? void 0 : _crumb$data.status_code) === 0 || ((_crumb$data2 = crumb.data) === null || _crumb$data2 === void 0 ? void 0 : _crumb$data2.status_code) === '0' || ((_crumb$data3 = crumb.data) === null || _crumb$data3 === void 0 ? void 0 : _crumb$data3.status_code) === null);
  });
  if (isChirpOrFetchError && hasStatusCode0OrNull) {
    return false;
  }
  return true;
}
export function setupRavenFilters() {
  Raven.setShouldSendCallback(shouldSendToRaven);
}